import { SocieteModel } from '../models/simple-types/societe.model';

export class FilterFournDTO {

  public societe: SocieteModel = null;
  public idSociete: number = null;
  public code: string = null;
  public libelle: string = null;
  public ville: string = null;
  public cp: string = null;
  public siret: string = null;

  public descending = false;
  public pageNumber = 0;
  public pageSize = 10;
  public order = 'code';

  }
